<template>
  <page-outline :title="$t('Webheader.message_routing')">
    <template slot="pageContent">
      <div class="listPage overflow-hidden">
        <b-row class="justify-content-start no-gutters">
          <b-button class="btn btnFilter" :disabled="activateSpinner"
            @click="onRefresh">
            <i class="fa-light fa-rotate-right fs-14px"></i>
          </b-button>
          <div class="ml-3 mt-xl-0 text-xl-center">
            <b-button-group class="">
              <b-button v-if="messageRoutingIn.length" :variant="tabName === 0 ? 'primary' : ''" @click="tabName = 0">{{ $t('common.routing.in') }}</b-button>
              <b-button v-if="messageRoutingOut.length" :variant="tabName === 1 ? 'primary' : ''" @click="tabName = 1">{{ $t('common.routing.out') }}</b-button>
            </b-button-group>
          </div>
        </b-row>

        <br />
        <b-tabs v-model="tabName" nav-class="d-none">
          <b-tab :title="$t('common.routing.in')">
            <b-row>
              <b-col md="12">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else>
                  <!-- DR : Changer de fixed à relative pour que les tables soient scrollable (pratique pour les users mobile/tablette)-->
                  <b-table hover relative responsive
                    v-if="messageRoutingIn.length"
                    class="mt-3 table-striped"
                    :items="messageRoutingIn"
                    :fields="fields"
                    selectable select-mode="single" @row-selected="seeDetails">
                    <template #cell(Standard)="data">
                      <span v-if="data.value === '1'">{{$t('requestToPay.norms.SRTP')}}</span>
                      <span v-else-if="data.value === '2'">{{$t('requestToPay.norms.HRTP')}}</span>
                      <span v-else></span>
                    </template>
                  </b-table>
                  <label class="font-bold w-100 d-flex justify-content-center mt-3" v-else>{{ $t('common.no_result') }}</label>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab :title="$t('common.routing.out')">
            <b-row>
              <b-col md="12">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else>
                  <!-- DR : Changer de fixed à relative pour que les tables soient scrollable (pratique pour les users mobile/tablette)-->
                  <b-table hover relative responsive
                    v-if="messageRoutingOut.length"
                    class="mt-3 table-striped"
                    :items="messageRoutingOut"
                    :fields="fields"
                    selectable select-mode="single" @row-selected="seeDetails">
                    <template #cell(Standard)="data">
                      <span v-if="data.value === '1'">{{$t('requestToPay.norms.SRTP')}}</span>
                      <span v-else-if="data.value === '2'">{{$t('requestToPay.norms.HRTP')}}</span>
                      <span v-else-if="data.value === '3'">{{$t('common.norm.psd2')}}</span>
                      <span v-else></span>
                    </template>
                  </b-table>
                  <label class="font-bold w-100 d-flex justify-content-center mt-3" v-else>{{ $t('common.no_result') }}</label>
                </div>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
        <b-row class="justify-content-end mt-3 no-gutters" v-if="canAddMessageRouting && !activateSpinner">
          <b-button
          @click="addMessageRouting" variant="primary">
            <i class="fa-light fa-plus fs-17px"></i>
            <span>{{$t('common.routing.add_message')}}</span>
          </b-button>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'

import PageOutline from '@/components/common/PageOutline.vue'

import Spinner from '@/components/common/spinner.vue'
import Pagination from '@/components/common/pagination.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'MessageList',
  components: {
    'cm-pagination': Pagination,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    roleFromURL: {
      type: String,
      default: "0"
    },
  },
  computed: {
    canAddMessageRouting () {
      return this.$engine.rights.rightIs('messageRoutingConfig_ajouter', true)
    },
    fields () {
      return [
        { key: 'Message', label: this.$t('common.routing.message'), class: 'text-center table-condensed' },
        { key: 'ReceiverId', label: this.$t('common.routing.receiver_id'), class: 'text-center table-condensed' },
        { key: 'FormatName', label: this.$t('common.routing.format_name'), class: 'text-center table-condensed' },
        { key: 'ConfigType', label: this.$t('common.routing.config_type'), class: 'text-center table-condensed' },
        { key: 'ConfigName', label: this.$t('common.routing.config_name'), class: 'text-center table-condensed' },
        { key: 'Standard', label: this.$t('common.routing.standard'), class: 'text-center table-condensed' }
      ]
    },
    role () {
      return this.tabName
    }
  },
  data () {
    return {
      activateSpinner: false,
      messageRoutingIn: [],
      messageRoutingOut: [],
      pageCounter: 0,
      paginationObject: {},
      tabName: 0
    }
  },
  created () {
    //this.paginationObject['firstIndex'] = 1
    //this.paginationObject['maxResults'] = 3
    //this.paginationObject['nbResultsTotal'] = 0

    this.tabName = this.roleFromURL === "1" ? 1 : 0

    // this.getMessageRouting(0)
    // this.getMessageRouting(1)

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh()
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
  },
  methods: {
    addMessageRouting () {
      loadPage(this, {url: '/routing/messageDetails/create/' + this.role})
    },
    getMessageRouting (role) {
      let params = {
        Role: role
      }
      if (!this.$engine.rights.rightIs('super_admin', true)) {
        params.Norm = parseInt(this.$engine.user.getUserNorm())
      }
      this.$engine.routing.message.fetch(
        params, this.paginationObject.firstIndex, this.paginationObject.maxResults
      ).then(resp => {
        let messageRouting = {}

        this.paginationObject.nbResultsTotal = resp.data.TotalMessageRouting
        this.paginationObject.nbResults = resp.data.MessageRouting.length
        messageRouting = resp.data.MessageRouting

        this.updateItems(messageRouting, role)

        this.$f7.pullToRefreshDone()
      })
    },
    onRefresh (index = 1) {
      if (typeof index === 'object') {
        index = 1
      }
      this.activateSpinner = true
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.refreshItems(0)
      this.refreshItems(1)

      this.$f7.pullToRefreshDone()
    },
    refreshItems (role) {
      let that = this
      let params = {
        Role: role
      }
      if (!this.$engine.rights.rightIs('super_admin', true)) {
        params.Norm = parseInt(this.$engine.user.getUserNorm())
      }
      this.$engine.routing.message.fetch(
        params, this.paginationObject.firstIndex, this.paginationObject.maxResults
      ).then(resp => {
        let messageRouting = {}

        that.paginationObject.nbResultsTotal = resp.data.TotalMessageRouting
        that.paginationObject.nbResults = resp.data.MessageRouting.length
        messageRouting = resp.data.MessageRouting

        that.updateItems(messageRouting, params.Role)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    seeDetails (items) {
      let that = this
      let message = items[0]

      this.$engine.routing.message.clickedMessage = message
      loadPage(this, {url: '/routing/messageDetails/details/' + this.role})
    },
    updateItems (requests, role) {
      if(role === 0) {
        this.messageRoutingIn = requests
        this.tabName = 1
      }
      if(role === 1) {
        this.messageRoutingOut = requests
      }
    }
  }
}
</script>
